import { Component, OnInit } from '@angular/core';
import { ActivatedRoute,Router } from '@angular/router';
import { UserService } from 'src/app/Services/User/user.service';
import { ToastService } from 'src/app/Services/toast/toast.service';
@Component({
  selector: 'app-consult-alumni',
  templateUrl: './consult-alumni.component.html',
  styleUrls: ['./consult-alumni.component.scss']
})
export class ConsultAlumniComponent implements OnInit {

  alumni : any ; 
  id : any ; 
  style1 : string  ;
  isOpened : boolean ; 
  toggleStyle : string ; 
  msg =''; 
  showmsg =  true ; 
  constructor(private act :ActivatedRoute , 
    private _shared:UserService , 
    private router:Router,
    private toast:ToastService) { }

  ngOnInit(): void {
    this.id = this.act.snapshot.paramMap.get('id'); 
    this._shared.getAlumibyId(this.id).
    subscribe(
      res=>{
        this.alumni = res ;  

      },
      err =>{ 
        console.log(err)
      })
  }

}
